import { render, staticRenderFns } from "./PushTopMenu.vue?vue&type=template&id=c63a955a&scoped=true&"
import script from "./PushTopMenu.vue?vue&type=script&lang=js&"
export * from "./PushTopMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c63a955a",
  null
  
)

export default component.exports